// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudDownloadOutlinedSvg from "@fishx/icons-svg/es/asn/CloudDownloadOutlined";
import FishxIcon from '../components/FishxIcon';

var CloudDownloadOutlined = function CloudDownloadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudDownloadOutlinedSvg
  }));
};

CloudDownloadOutlined.displayName = 'CloudDownloadOutlined';
export default React.forwardRef(CloudDownloadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloudDownloadOutlined.js
// module id = 2250
// module chunks = 0